import React from 'react';
import { CheckInput, FormGroupInput, LabelInput } from './styles';

function RadioCheckGroup({ options, selectedOption, onChange, label, type, disabled }) {
    const handleOptionChange = (event) => {
        const selectedValue = event.target.value;
        onChange(selectedValue);
    };

    return (
        <FormGroupInput >
            <LabelInput id="inputGroup-sizing-sm" className="input-group-text">{label}</LabelInput>
                        
            {options.map((option, index) => (
                <CheckInput
                    key={index}
                    type={type}
                    id={`${label}-${index}`}
                    label={option.label}
                    value={option.value}
                    disabled={disabled}
                    checked={type === "radio" ? selectedOption === option.value : selectedOption.includes(option.value)}
                    onChange={handleOptionChange}
                />
            ))}
        </FormGroupInput>
    );
}

export default RadioCheckGroup;
